import type { ClientInstance } from "@stelar/api-sdk";

import { buildClient } from "@stelar/api-sdk";

import { getEnvironmentValues } from "@/config/environment";

const { apiUrl, appVersion } = getEnvironmentValues();

export const client: ClientInstance = buildClient({
  apiUrl,
  xRequestedFor: "web-app",
  xRequestedVersion: appVersion,
});
